// Shared V2 dropdown preset for every Agent-Request surface (Marin bugfix
// 2026-07-22): the platform CustomDropdown's defaults (16px trigger text,
// px-4 py-3 16px option rows) are the CLUB-form density — on the V2 surfaces
// they rendered oversized against the 12.5px artboard triggers, on phone and
// desktop alike. This preset pins trigger AND menu to the artboard density.
// Spread it into CustomDropdown and add surface-specific props after it.
const v2DropdownProps = (compact = false) => ({
  className: "border-[#E2E8F0] rounded-[9px] whitespace-nowrap",
  paddingY: "py-0",
  style: {
    height: compact ? 32 : 36,
    paddingLeft: compact ? 11 : 12,
    paddingRight: compact ? 11 : 12,
    fontSize: compact ? "12px" : "12.5px",
    fontWeight: 500,
    color: "#334155",
  },
  // Menu panel + option rows in the same density as the trigger.
  dropdownClassName: "rounded-[9px] border-[#E2E8F0]",
  optionClassName: compact
    ? "!px-3 !py-1.5 !text-[12px] !font-medium"
    : "!px-3 !py-2 !text-[12.5px] !font-medium",
});

export default v2DropdownProps;
